import { render, staticRenderFns } from "./PostDataDetails.vue?vue&type=template&id=66f49a16&scoped=true&"
import script from "./PostDataDetails.vue?vue&type=script&lang=js&"
export * from "./PostDataDetails.vue?vue&type=script&lang=js&"
import style0 from "./PostDataDetails.vue?vue&type=style&index=0&id=66f49a16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f49a16",
  null
  
)

export default component.exports